export default "__VITE_ASSET__DsKejKbV__"